import React, { useState, useContext } from 'react';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { DataContext } from '../../init/getData';



function DatePicker(props) {

  const { setFilter, filter } = props;

  const { selectedYear } = useContext(DataContext);

  const minDate = `${selectedYear?.year}-01-01`;
  const maxDate = `${selectedYear?.year}-12-31`;


  const handleDateChange = (date, field) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [field]: date,
    }));
  };


  return (
    <div>


      <Form.Group>
        <Form.Control
          size="sm"
          type="date"
          className="date"
          value={filter.fromDate}
          min={minDate} // Explicitly set min
          max={maxDate} // Explicitly set max
          onChange={(e) => handleDateChange(e.target.value, 'fromDate')}
        />
      </Form.Group>


      <Form.Group>
        <Form.Control
          size="sm"
          type="date"

          className="date"
          value={filter.toDate}
          min={minDate}
          max={maxDate}
          onChange={(e) => handleDateChange(e.target.value, 'toDate')}
        />
      </Form.Group>



    </div>
  );
}

export default DatePicker;
